module.exports = __webpack_public_path__ + "static/media/ribbon_y.a6764001.svg";